import DataTable from 'react-data-table-component';
import { IImportar } from "../../interfaces/IImportar";

const ImportarNovoModalRegimeTabela = ({ colunas, itens }: { colunas: any, itens: IImportar[] }) => {
    const customStyles = {
        headCells: {
            style: {
                backgroundColor: '#6773c7',
                color: 'white',
                fontFamily: 'Assistant',
                fontSize: '14px',
                padding: '10px 0 10px 25px',
                margin: '0',
            }
        },
        cells: {
            style: {
                color: '#A3A3A3',
                fontFamily: 'Merriweather Sans',
                fontSize: '14px',
                padding: '15px 0 15px 25px'
            }
        }
    };

    return <>
        {
            itens.length > 0 ?
                <DataTable columns={colunas} data={itens} customStyles={customStyles} dense />
            :
                <h2 className="mt-5">Não possuem eventos para serem exibidos</h2>
        }
    </>
}

export default ImportarNovoModalRegimeTabela;